module.exports = __webpack_public_path__ + "img/black-label.c3262809.svg";